import React from "react";
import { Stack, Column, Columns } from "@origin-digital/ods-core";
import { Field } from "formik";
import FormikSelectField from "../FormComponents/FormikSelectField";
import {
  allAustralianStates,
  premiseTypes,
  streetSuffixes,
  streetTypeOptions,
} from "../FormComponents/AddressConstants";
import { GeneralTextFieldWithAutoCompleteOn } from "../FormComponents/GeneralTextFieldWithAutoCompleteOn";

const PostalAddressFields: React.FC = () => {
  return (
    <Columns collapseBelow="xl">
      <Column width="5/6">
        {/* Postal address fields */}
        <Stack space={["xlarge", "xlarge"]}>
          <Columns
            collapseBelow="md"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column>
              <Field
                component={GeneralTextFieldWithAutoCompleteOn}
                name="postalUnitNo"
                label="Unit/Premise no."
              />
            </Column>
            <Column>
              <Field
                name="postalPremiseType"
                label="Premise type"
                component={FormikSelectField}
                options={premiseTypes}
              />
            </Column>
          </Columns>
          <Columns
            collapseBelow="md"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column>
              <Field
                component={GeneralTextFieldWithAutoCompleteOn}
                name="postalLevelNo"
                label="Level no."
              />
            </Column>
            <Column>
              <Field
                component={GeneralTextFieldWithAutoCompleteOn}
                name="postalStreetNo"
                label="Street no."
                maxLength={10}
              />
            </Column>
          </Columns>
          <Field
            component={GeneralTextFieldWithAutoCompleteOn}
            name="postalStreetName"
            label="Street name"
          />
          <Columns
            collapseBelow="md"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column>
              <Field
                name="postalStreetType"
                label="Street type"
                component={FormikSelectField}
                options={streetTypeOptions}
              />
            </Column>
            <Column>
              <Field
                name="postalSuffix"
                label="Suffix"
                component={FormikSelectField}
                options={streetSuffixes}
              />
            </Column>
          </Columns>
          <Field
            component={GeneralTextFieldWithAutoCompleteOn}
            name="postalSuburb"
            label="Suburb"
          />
          <Columns
            collapseBelow="md"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column>
              <Field
                name="postalState"
                label="State"
                component={FormikSelectField}
                options={allAustralianStates}
              />
            </Column>
            <Column>
              <Field
                component={GeneralTextFieldWithAutoCompleteOn}
                name="postalPostcode"
                label="Postcode"
              />
            </Column>
          </Columns>
        </Stack>
        {/* End Postal address fields */}
      </Column>
    </Columns>
  );
};

export default PostalAddressFields;
